export class MonacoWorkspace {
    workspaceFolders;
    rootPath;
    // eslint-disable-next-line no-useless-constructor
    constructor(workspaceFolders, rootPath) {
        this.workspaceFolders = workspaceFolders;
        this.rootPath = rootPath;
    }
}
//# sourceMappingURL=monaco-workspace.js.map